import React from 'react';
import SortTable from '../../SortTable';
import {stringISOtoUS} from "../../../date-converter";
import {formatName, percent} from "../../../utils";
import dollars from '../../../dollar-format';

const columns = [{
    name: 'Date',
    render: (el) => (el.DATE ? stringISOtoUS(el.DATE) : '-'),
}, {
    name: 'Status',
    render: (el) => (el.STATUS ? el.STATUS : '-'),
}, {
    name: 'Agent',
    render: (el) => (el.LISTING_AGENT_1_FIRST_NAME ? formatName(el, 'LISTING_AGENT_1_') : formatName(el, 'LISTING_AGENT_4_')),
}, {
    name: 'Firm',
    render: (el) => (el.LISTING_AGENT_FIRM_NAME ? el.LISTING_AGENT_FIRM_NAME : '-'),
}, {
    name: 'Price',
    render: (el) => (el.PRICE ? dollars(el.PRICE) : '-'),
}, {
    name: 'Cap Rate',
    render: (el) => (el.CAP_RATE ? percent(el.CAP_RATE) : '-'),
}, {
    name: 'NOI',
    render: (el) => (el.NET_OPERATING_INCOME ? dollars(el.NET_OPERATING_INCOME) : '-'),
}, {
    name: 'PSF',
    render: (el) => (el.PRICE_PER_SQFT ? dollars(el.PRICE_PER_SQFT, true) : '-'),
}, {
    name: 'Base Rent',
    render: (el) => (el.BASE_RENT ? dollars(el.BASE_RENT) : '-'),
}, {
    name: 'Rent/Sq Ft',
    render: (el) => (el.RENT_PER_SQFT ? dollars(el.RENT_PER_SQFT, true) : '-'),
}, {
    name: 'Occupancy',
    render: (el) => (el.VACANCY ? percent(el.VACANCY) : '-'),
}];

const PropertyHistory = ({data, deleted}) => (
    <div className={`Property-history${deleted ? ' deleted' : ''}`}>
        <div className='invisible'/>
        {
            data && data.length ?
                <SortTable
                    columns={columns}
                    items={data}
                    classNameModifier='property-history'
                />
                :
                <div className='no-results'>No results.</div>
        }
    </div>
);

export default PropertyHistory;